/**
 * Deep-clone JSON-serializable values.
 * Prefers `structuredClone` when available; falls back for AudioWorklet
 * (where structuredClone is missing in some browsers).
 *
 * Access via `globalThis` so a bare `structuredClone` identifier cannot throw
 * ReferenceError inside worklet scopes.
 */
export function deepClone<T>(value: T): T {
  const clone = (globalThis as { structuredClone?: <U>(v: U) => U }).structuredClone;
  if (typeof clone === "function") {
    return clone(value);
  }
  return JSON.parse(JSON.stringify(value)) as T;
}
